import { createContext } from 'react';

interface DropdownMenuContextValue {
  closeModal: () => void;
  isTriggered: boolean;
}

export const DropdownMenuContext = createContext<DropdownMenuContextValue>({
  closeModal: () => {},
  isTriggered: false,
});

DropdownMenuContext.displayName = 'DropdownMenuContext';
